import(/* webpackMode: "eager" */ "/codebuild/output/src1869817006/src/app/home/page.tsx");
